module.exports = __webpack_public_path__ + "static/media/scroll.9f053ce7.svg";